/**
 * Single readable line for admin Axios errors (validation, HTTP status, request id).
 * UI copy in English (admin product standard).
 */
export function formatAdminApiError(error, fallback = "Request failed") {
  const status = error?.response?.status;
  const d = error?.response?.data;
  const hdrs = error?.response?.headers || {};
  const rid = hdrs["x-request-id"] || hdrs["X-Request-Id"] || d?.requestId;
  let msg = "";
  if (typeof d?.message === "string" && d.message.trim()) msg = d.message.trim();
  else if (typeof d?.error === "string" && d.error.trim()) msg = d.error.trim();
  else if (Array.isArray(d?.errors)) {
    const parts = d.errors.map((e) =>
      typeof e === "string" ? e : e?.msg || e?.message || JSON.stringify(e)
    );
    if (parts.length) msg = parts.join("; ");
  }
  if (!msg && d && typeof d === "object") {
    try {
      const s = JSON.stringify(d);
      if (s !== "{}" && s.length < 400) msg = s;
    } catch {
      /* ignore */
    }
  }
  if (!msg) msg = (typeof error?.message === "string" && error.message) || fallback;
  const suffix =
    status != null ? ` (HTTP ${status}${rid ? ` · ref ${rid}` : ""})` : rid ? ` (ref ${rid})` : "";
  return `${msg}${suffix}`;
}
